import { Injectable } from '@angular/core';
import * as Konva from 'konva';
import {
    GROUP_PREFIX,
    TEXT_PREFIX,
    TEXT_RECTANGLE_PREFIX,
} from '../containers/editor/consts/editorConsts';
import { PageItem, TreeItem } from '../containers/editor/models/tree';
@Injectable({
    providedIn: 'root',
})
export class UtilService {
    constructor() {}

    guid(noDash?: boolean) {
        function s4() {
            return Math.floor((1 + Math.random()) * 0x10000)
                .toString(16)
                .substring(1);
        }
        const dash = noDash ? '' : '-';
        return s4() + s4() + dash + s4() + dash + s4() + dash + s4() + dash + s4() + s4() + s4();
    }
    tickFromDateString(properDateStr?: string) {
        const date = properDateStr ? new Date(properDateStr) : new Date();
        return date.getTime() * 10000 + 621355968000000000;
    }
    cleanObject(obj): any {
        Object.keys(obj).forEach(key => {
            if (!obj[key] && obj[key] !== 0) {
                delete obj[key];
            }
        });
        return obj;
    }
    createCopy(objectToCopy): any {
        return JSON.parse(JSON.stringify(objectToCopy));
    }
    breakGroup(group) {
        const subLayers = {
            image: undefined as Konva.Image,
            rectangleText: undefined as Konva.Rect,
            text: undefined as Konva.Text,
        };

        const imageId = group.attrs.id.replace(GROUP_PREFIX, '');
        const textId = TEXT_PREFIX + imageId;
        const rectangleText = TEXT_PREFIX + TEXT_RECTANGLE_PREFIX + imageId;

        if (group.children.length !== 0) {
            for (let i = 0; i < group.children.length; i++) {
                if (group.children[i].attrs.id === imageId) {
                    subLayers.image = group.children[i] as Konva.Image;
                } else if (group.children[i].attrs.id === textId) {
                    subLayers.text = group.children[i] as Konva.Text;
                } else if (group.children[i].attrs.id === rectangleText) {
                    subLayers.rectangleText = group.children[i] as Konva.Rect;
                }
            }
        }
        return subLayers;
    }
    getTreePageByIndex(tree: TreeItem, index): PageItem {
        if (!tree || tree.pages.length === 0) {
            return undefined;
        }
        if (index === -1) {
            return tree.cover;
        }
        return tree.pages[index];
    }
    isInTime(time: number, expirationLimit: number): boolean {
        if (!time || !expirationLimit) {
            return false;
        }
        const expiration = new Date(Date.now() - expirationLimit);
        const timeObj = new Date(time);
        return expiration < timeObj;
    }
    getRegionPageNumber(page, region): number {
        if (page === -1) {
            return -1;
        }
        if (region === 0) {
            return page * 2 + 1;
        } else {
            return page * 2;
        }
    }
    removeEventListeners(el) {
        const elClone = el.cloneNode(true);

        el.parentNode.replaceChild(elClone, el);
    }
}
